<template lang="pug">
    .about-sidebar
        .about-sidebar-options
            router-link.about-sidebar-option(v-for="option in options", tag="a", :to="option.path", :key="option.name", :class="option.isactive? 'active' : ''")
                | {{ option.name }}
        .contact-button-sidebar(v-if="contact")
            router-link.contact-sidebar-button-img(:to="lang == 'EN' ? '/en/contact' : '/es/contacto'")
                img(:src="lang == 'EN' ? image : imageen")
</template>

<script>
import image from '@img/ContactUs.jpg'
import imageen from '@img/Contactanos.jpg'
export default {
    props: ["options", "contact", "isactive", "lang"],
    data: function(){
        return{
            image: image,
            imageen: imageen
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/atoms/PmSidebar.vue